import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { BiErrorCircle } from "react-icons/bi";

const ErrorPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const reason = queryParams.get("reason");

    const getErrorMessage = () => {
        switch (reason) {
            case "google-oauth":
                return "Google Login failed. Please try again or use another login method.";
            case "oauth_failed":
                return "Authentication failed. Please try again.";
            default:
                return "Something went wrong. Please try again later.";
        }
    };

    return (
        <Container className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
            <BiErrorCircle size={80} color="#dc3545" className="mb-4" />
            <h2 className="mb-3 text-danger">Oops! An Error Occurred</h2>
            <p className="lead mb-4">{getErrorMessage()}</p>

            <div className="d-flex gap-3">
                <Button variant="outline-secondary" onClick={() => navigate(-1)}>
                    Go Back
                </Button>
                <Button variant="primary" onClick={() => navigate("/")}>
                    Go to Home
                </Button>
            </div>
        </Container>
    );
};

export default ErrorPage;
